import {EventBus} from "../utils/event-bus";
import Wallkit from './wallkit.esm.min';
import {get} from 'lodash';
import debug from '../utils/debug';

export default {
  install: async (Vue) => {
    const loadSquare = (resource) => {
      debug.log('LOAD SQUARE');

      const defaultPaymentSystem = get(resource, 'default_payment_system');
      const isLiveMode = get(resource, 'payments_in_live_mode');

      if (defaultPaymentSystem === 'square') {
        Wallkit.unsubscribeLocalEvent('resource', loadSquare);

        const DEV_SQUARE_URL = 'https://sandbox.web.squarecdn.com/v1/square.js';
        const PROD_SQUARE_URL = 'https://web.squarecdn.com/v1/square.js';

        if (!document.getElementById('square-script')) {
          const scriptElement = document.createElement('script');
          scriptElement.src = isLiveMode ? PROD_SQUARE_URL : DEV_SQUARE_URL;
          scriptElement.id = 'square-script';
          scriptElement.onload = () => {
            debug.log('SQUARE INIT');
            EventBus.$emit('square-loaded');
          }

          document.body.appendChild(scriptElement);
        }
      } else {
        Wallkit.unsubscribeLocalEvent('resource', loadSquare);
      }
    }

    Wallkit.subscribeLocalEvent('resource', loadSquare);
  }
};



// WEBPACK FOOTER //
// ./src/plugins/square.js